// components/ClientAuthGuard.tsx
'use client';

import { useAuth } from "@/hooks/useAuth";
import { usePageAuth } from "@/hooks/usePageAuth";
import { registerLogoutHandler } from "@/lib/auth/authEvents";
import { useState, useEffect } from "react";

interface ClientAuthGuardProps {
    children: React.ReactNode;
}

export function ClientAuthGuard({ children }: ClientAuthGuardProps) {
    const { isChecking } = usePageAuth();
    const { logoutHandler } = useAuth();

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        registerLogoutHandler(logoutHandler)
    }, []);

    if (!mounted || isChecking) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return <>{children}</>;
}